import { render, staticRenderFns } from "./vip-goods.vue?vue&type=template&id=248751d3"
import script from "./vip-goods.vue?vue&type=script&lang=js"
export * from "./vip-goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports